import { render } from "./ExamStudentAnswersView.vue?vue&type=template&id=4105bdef&scoped=true"
import script from "./ExamStudentAnswersView.vue?vue&type=script&lang=js"
export * from "./ExamStudentAnswersView.vue?vue&type=script&lang=js"

import "./ExamStudentAnswersView.vue?vue&type=style&index=0&id=4105bdef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4105bdef"]])

export default __exports__